import { useEffect, useMemo } from 'react'
import { useEffectEvent } from '@funkit/connect-core'

import { useDynamicConfig } from '../statsig/useDynamicConfig'

import { isCountryBlocked } from './isCountryBlocked'
import { useUserIpInfo } from './useUserIpInfo'

interface UseCheckoutBlockedParams {
  onCheckoutBlocked?: () => void
}

interface UseCheckoutBlockedResult {
  isGeoblocked: boolean
  isLoadingGeoCheck: boolean
}

export function useCheckoutBlocked(
  params: UseCheckoutBlockedParams,
): UseCheckoutBlockedResult {
  const { userIpInfo, isLoadingGeoCheck } = useUserIpInfo()
  const blockedCountries = useDynamicConfig('blockedcountries')

  const isGeoblocked = useMemo(() => {
    if (isLoadingGeoCheck) {
      return false
    }
    if (!userIpInfo) {
      return true
    }
    return isCountryBlocked(blockedCountries, userIpInfo)
  }, [blockedCountries, isLoadingGeoCheck, userIpInfo])

  const onCheckoutBlockedEvent = useEffectEvent(() => {
    params.onCheckoutBlocked?.()
  })

  useEffect(() => {
    if (isGeoblocked) {
      onCheckoutBlockedEvent()
    }
  }, [isGeoblocked])

  return { isGeoblocked, isLoadingGeoCheck }
}
